import React, {useEffect, useState} from 'react'
import {ArrowDownOnSquareIcon, XMarkIcon} from "@heroicons/react/24/solid";
import SelectColorTypeDetails from "../../../design/components/design-editor/settings/select-color-type-details";
import _ from "lodash";
import ShowProgressSpinner from "../../../common/ui/show-progress-spinner"
import RenderFields from "../../../common/ui/render-fields";
import ShowTabsList from "../../../common/ui/show-tabs-list";
import {
    DEFAULT_MULTI_VARIANT_DESIGNER_TAB,
    MULTI_VARIANT_DESIGNER_TABS_LIST
} from "../../constants/design.constant";
import ShowDesignDetail from "../common/show-design-detail";
import SelectTags from "../../../tag/select-tags";
import ImageSidebarSection from "../../../image/image-sidebar/image-sidebar-section";
import {searchThemes} from "../../../theme/services/theme-data-service";
import {searchTags} from "../../../common/services/tag-data-service";

const defaultSettings: any = {
    background: {colorType: 'solid'},
    images: []
}

const tabsList = MULTI_VARIANT_DESIGNER_TABS_LIST;

const defaultTagDetail = {
    themes: {},
    themeList: [],
    tags: {},
    tagList: [],
};

const SelectMultipleImages = ({allTags, addImageList, needDownloadUrl = false}) => {
    const [selectedImagesList, setSelectedImagesList] = useState([]);
    const [selectedImageIdsList, setSelectedImageIdsList] = useState([]);
    const [filterDetail, setFilterDetail] = useState(defaultTagDetail);
    const [refreshImages, setRefreshImages] = useState(false);

    const handleFilterTagChanges = async (event) => {
        const {name, value} = event.target;
        const existingFilterDetail = {...filterDetail};
        existingFilterDetail[name] = value;

        if (name === 'tagList') {
            const tempTags = {};
            _.forEach(value, tagId => {
                tempTags[tagId] = true;
            });

            existingFilterDetail['tags'] = tempTags;
            existingFilterDetail['tagList'] = value;
        }

        setFilterDetail(existingFilterDetail);
    }

    const handleRemoveAllImages = () => {
        setSelectedImagesList([]);
        setSelectedImageIdsList([]);
        addImageList([]);
    }

    const handleSelectAllImages = (imagesList) => {
        const existingSelectedImagesList = [...selectedImagesList];
        const tempSelectedImageIdsList = _.map(existingSelectedImagesList, 'id');
        const existingSelectedImageIdsList = [...selectedImageIdsList];

        _.forEach(imagesList, (imageDetail) => {
            if (tempSelectedImageIdsList.indexOf(imageDetail.id) === -1) {
                existingSelectedImagesList.push(imageDetail);
                tempSelectedImageIdsList.push(imageDetail.id);
            }

            if (existingSelectedImageIdsList.indexOf(imageDetail.id) === -1) {
                existingSelectedImageIdsList.push(imageDetail.id);
            }
        });

        setSelectedImagesList(existingSelectedImagesList);
        setSelectedImageIdsList(existingSelectedImageIdsList);
        addImageList(existingSelectedImagesList);
    }

    const handleSelectedImage = (imageDetail) => {
        const existingSelectedImagesList = [...selectedImagesList];
        const tempSelectedImageIdsList = _.map(existingSelectedImagesList, 'id');

        if (tempSelectedImageIdsList.indexOf(imageDetail.id) === -1) {
            imageDetail.isAdded = true;
            existingSelectedImagesList.push(imageDetail);
        }

        const existingSelectedImageIdsList = [...selectedImageIdsList];
        if (existingSelectedImageIdsList.indexOf(imageDetail.id) === -1) {
            existingSelectedImageIdsList.push(imageDetail.id);
        }

        setSelectedImagesList(existingSelectedImagesList);
        setSelectedImageIdsList(existingSelectedImageIdsList);
        addImageList([imageDetail]);
    }

    return (
        <>
            {allTags &&
                <div
                    className="h-44 overflow-y-scroll border-gray-400 border bg-blue-50 rounded">
                    <SelectTags
                        existingTags={filterDetail?.tagList}
                        allTags={allTags}
                        handleSelectTagsChanges={handleFilterTagChanges}
                        showAddTag={false}
                        showClearSelectedTags={true}
                        showClearSelectedTagsIcon={true}/>
                </div>
            }

            <div
                className="multi-variant-designer-images-sidebar-container-child overflow-y-scroll border-gray-400 border bg-gray-400 rounded mt-4">
                <ImageSidebarSection
                    setSelectedImage={handleSelectedImage}
                    tags={filterDetail?.tagList}
                    ignoreInitialSelection={true}
                    selectedImageIdsList={selectedImageIdsList}
                    refreshImages={refreshImages}
                    setRefreshImages={setRefreshImages}
                    showSelectAll={true}
                    handleSelectAllImages={handleSelectAllImages}
                    handleRemoveAllImages={handleRemoveAllImages}/>
            </div>
        </>
    )
}

export default SelectMultipleImages
